import { CSSProperties, FC, PropsWithChildren } from 'react';
import { clsx } from '@team/clsx';
import css from './style.module.css';

type Props = PropsWithChildren<{ style?: CSSProperties }> & HasClassName;

export const Layout: FC<Props> = (props) => (
  <div {...props} className={clsx(props.className, css.root)} />
);
